import { CivilIdentitySearchCase } from './civil-identity-search-case';

export class CivilIdentitySearchResponse {
    cases: CivilIdentitySearchCase[];
    pageNumber: number;
    pageSize: number;
    totalRecords: number;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-search-response.ts